import { useMemo } from "react";
import { appendMarketplaceAttributionParamsToHref } from "@/utils/functions/marketplaceAttribution";
import useResolvedMarketplaceAttribution from "@/hooks/useResolvedMarketplaceAttribution";

type MarketplaceAttributionHrefOptions = {
  includeNextDestination?: boolean;
};

export default function useMarketplaceAttributionHref(
  href?: string,
  { includeNextDestination = false }: MarketplaceAttributionHrefOptions = {},
): string {
  const source = useResolvedMarketplaceAttribution().toString();

  return useMemo(
    () =>
      appendMarketplaceAttributionParamsToHref({
        href,
        source,
        includeNextDestination,
      }),
    [href, includeNextDestination, source],
  );
}
